/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdMaterialsMetrics200,
  GetApiV1ClassroomdisciplineIdMaterialsMetrics401,
  GetApiV1ClassroomdisciplineIdMaterialsMetrics404,
  GetApiV1ClassroomdisciplineIdMaterialsMetricsPathParams,
  GetApiV1ClassroomdisciplineIdMaterialsMetricsQueryResponse,
} from "../../types/classPlanningMaterialController/GetApiV1ClassroomdisciplineIdMaterialsMetrics.ts";
import { materialMetricViewModelSchema } from "../materialMetricViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdMaterialsMetricsPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsMetricsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdMaterialsMetrics200Schema = z.array(
  z.lazy(() => materialMetricViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsMetrics200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdMaterialsMetrics401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsMetrics401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdMaterialsMetrics404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsMetrics404>;

export const getApiV1ClassroomdisciplineIdMaterialsMetricsQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdMaterialsMetrics200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsMetricsQueryResponse>;
